<template>
    <div v-if="offer" class="mb-5">
        <strong class="d-block">{{ offer.info.description }}</strong>
        <strong v-if="searchRequest" class="d-block">
            {{ $t('date') }}: {{ $filters.dateFormat(searchRequest.dateTime) }}
        </strong>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, HIDE_CONDITIONAL_MODAL_INFO, SHOW_TRANSFER_CONDITIONS_INFO} from '@/utils/event-bus'

    @Component
    export class TransferConditionsModalInfo extends Vue {
        show = false
        searchRequest = {}
        offer = null

        mounted() {
            EventBus.$on(SHOW_TRANSFER_CONDITIONS_INFO, this.showInfo)
            EventBus.$on(HIDE_CONDITIONAL_MODAL_INFO, this.hideInfo)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_TRANSFER_CONDITIONS_INFO, this.showInfo)
            EventBus.$off(HIDE_CONDITIONAL_MODAL_INFO, this.hideInfo)
        }

        showInfo({searchRequest, offer}) {
            this.searchRequest = searchRequest
            this.offer = offer
        }

        hideInfo() {
            this.offer = null
        }
    }

    export default TransferConditionsModalInfo
</script>
